export default import.meta.ROLLUP_FILE_URL_$Uz2JHrPn9gid3VmLp8wGA;